export default __webpack_public_path__ + "static/media/sass.6dd8c997.svg";